// extracted by mini-css-extract-plugin
export default {"warningIcon":"AdminHelper_warningIcon__GVinF"};